import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import React from "react";
import FeatherIcon from "feather-icons-react";
import { breadCrumbs } from "../menu-items-list/model/menu-items-list.constants";
import FormBuilderComponent from "@molecules/form-builder/form-builder.component";
import CardComponent from "@atoms/card/card.component";

const ActionContent = ({ handleSaveClick, handleBackClick }) => {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={handleSaveClick}
      >
        <FeatherIcon icon="save" size={17} />
      </button>

      <button
        type="button"
        className="btn btn-outline-primary btn-sm ml-2"
        onClick={handleBackClick}
      >
        <FeatherIcon icon="arrow-left" size={17} />
      </button>
    </>
  );
};

const MenuItemsCreateTemplateComponent = ({
  templateModal: { formTriggers, formInputs },
  templateEvents: { handleMenuItemSubmit, handleTriggerClick, handleBackClick },
}) => {
  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"Create Menu Item"}
        breadCrumbs={[
          ...breadCrumbs,
          { name: "Create ", menu_url: "/system/menu-items/create" },
        ]}
        actionContent={
          <ActionContent
            handleSaveClick={() => handleTriggerClick("SUBMIT")}
            handleBackClick={handleBackClick}
          />
        }
      />

      <CardComponent>
        <FormBuilderComponent
          loading={formTriggers.loading}
          inputFields={formInputs}
          submitTrigger={formTriggers.submitTrigger}
          onSubmit={handleMenuItemSubmit}
        />
      </CardComponent>
    </PageWrapperComponent>
  );
};

export default MenuItemsCreateTemplateComponent;
